<template>
    <section class="mt-56 dashboard-outer-section">
        <div class="row dashboard-row align-items-stretch">
            <div class="col-lg-6 dashboard-card">
                <div class="dashboard-card__content ">
                    <div
                        class="d-flex flex-column flex-md-row justify-content-md-between align-items-md-center"
                    >
                        <h3 class="h3 cabinet-section__dashboard-title">
                            Топ просмотров
                        </h3>

                        <div class="cabinet-filter-wrap">
                            <select
                                class="select js-selectpicker mr-0 hidden"
                                data-title="Период:"
                                data-width="170px"
                            >
                                <option> Сегодня </option>
                                <option> Вчера </option>
                                <option selected> Последние 7 дней </option>
                                <option> Последние 30 дней </option>
                                <option> Этот месяц </option>
                                <option> Этот год </option>
                                <option> Прошлый год </option>
                                <option> Все время </option>
                            </select>
                        </div>
                    </div>

                    <div v-if="true" class="dashboard-empty">
                        <img
                            src="/img/icons/empty-views.svg"
                            class="dashboard-empty__img ofi"
                        />
                        <div class="dashboard-empty__descr text-center">
                            <div class="dashboard-empty__title">
                                У вас пока что нет ни одного просмотра.
                            </div>
                            Как только ритейлеры начнут заказывать ваши изделия,
                            вы увидите здесь изделия 5 изделий с самый большим
                            количеством просмотров.
                        </div>
                    </div>

                    <div v-else>
                        <div
                            class="d-flex justify-content-between align-items-center dashboard-product__row"
                        >
                            <a href="javascript:void(0)"
                                ><img
                                    src="/img/product3.png"
                                    alt=""
                                    class="dashboard-product__img ofi"
                            /></a>
                            <a
                                href="javascript:void(0)"
                                class="dashboard-product__link app-link mr-auto"
                                ><span>Арт.</span>67896677776</a
                            >
                            <span>5000</span>
                            <span class="dashboard-product__icon"></span>
                        </div>
                        <div
                            class="d-flex justify-content-between align-items-center dashboard-product__row"
                        >
                            <a href="javascript:void(0)"
                                ><img
                                    src="/img/product3.png"
                                    alt=""
                                    class="dashboard-product__img ofi"
                            /></a>
                            <a
                                href="javascript:void(0)"
                                class="dashboard-product__link app-link mr-auto"
                                ><span>Арт.</span>67896677776</a
                            >
                            <span>4000</span>
                            <span class="dashboard-product__icon"></span>
                        </div>
                        <div
                            class="d-flex justify-content-between align-items-center dashboard-product__row"
                        >
                            <a href="javascript:void(0)"
                                ><img
                                    src="/img/product3.png"
                                    alt=""
                                    class="dashboard-product__img ofi"
                            /></a>
                            <a
                                href="javascript:void(0)"
                                class="dashboard-product__link app-link mr-auto"
                                ><span>Арт.</span>67896677776</a
                            >
                            <span>3200</span>
                            <span class="dashboard-product__icon"></span>
                        </div>
                        <div
                            class="d-flex justify-content-between align-items-center dashboard-product__row"
                        >
                            <a href="javascript:void(0)"
                                ><img
                                    src="/img/product3.png"
                                    alt=""
                                    class="dashboard-product__img ofi"
                            /></a>
                            <a
                                href="javascript:void(0)"
                                class="dashboard-product__link app-link mr-auto"
                                ><span>Арт.</span>67896677776</a
                            >
                            <span>500</span>
                            <span class="dashboard-product__icon"></span>
                        </div>
                        <div
                            class="d-flex justify-content-between align-items-center dashboard-product__row"
                        >
                            <a href="javascript:void(0)"
                                ><img
                                    src="/img/product3.png"
                                    alt=""
                                    class="dashboard-product__img ofi"
                            /></a>
                            <a
                                href="javascript:void(0)"
                                class="dashboard-product__link app-link mr-auto"
                                ><span>Арт.</span>67896677776</a
                            >
                            <span>300</span>
                            <span class="dashboard-product__icon"></span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /dashboard-card -->

            <div class="col-lg-6 dashboard-card">
                <div class="dashboard-card__content ">
                    <div
                        class="d-flex flex-column flex-md-row justify-content-md-between align-items-md-center"
                    >
                        <h3 class="h3 cabinet-section__dashboard-title">
                            Топ продаж
                        </h3>

                        <div class="cabinet-filter-wrap">
                            <select
                                class="select js-selectpicker mr-0 hidden"
                                data-title="Период:"
                                data-width="170px"
                            >
                                <option> Сегодня </option>
                                <option> Вчера </option>
                                <option selected> Последние 7 дней </option>
                                <option> Последние 30 дней </option>
                                <option> Этот месяц </option>
                                <option> Этот год </option>
                                <option> Прошлый год </option>
                                <option> Все время </option>
                            </select>
                        </div>
                    </div>

                    <div v-if="true" class="dashboard-empty">
                        <img
                            src="/img/icons/empty-orders.svg"
                            class="dashboard-empty__img ofi"
                        />
                        <div class="dashboard-empty__descr text-center">
                            <div class="dashboard-empty__title">
                                У вас пока что нет ни одного заказа.
                            </div>
                            Как только ритейлеры начнут заказывать ваши изделия,
                            вы увидите здесь изделия 5 изделий с самый большим
                            объемом продаж.
                        </div>
                    </div>

                    <div v-else>
                        <div
                            class="d-flex justify-content-between align-items-center dashboard-product__row"
                        >
                            <a href="javascript:void(0)"
                                ><img
                                    src="/img/product3.png"
                                    alt=""
                                    class="dashboard-product__img ofi"
                            /></a>
                            <a
                                href="javascript:void(0)"
                                class="dashboard-product__link app-link mr-auto"
                                ><span>Арт.</span>67896677776</a
                            >
                            <span>5000</span>
                            <span class="dashboard-product__pc">шт</span>
                        </div>
                        <div
                            class="d-flex justify-content-between align-items-center dashboard-product__row"
                        >
                            <a href="javascript:void(0)"
                                ><img
                                    src="/img/product3.png"
                                    alt=""
                                    class="dashboard-product__img ofi"
                            /></a>
                            <a
                                href="javascript:void(0)"
                                class="dashboard-product__link app-link mr-auto"
                                ><span>Арт.</span>67896677776</a
                            >
                            <span>4000</span>
                            <span class="dashboard-product__pc">шт</span>
                        </div>
                        <div
                            class="d-flex justify-content-between align-items-center dashboard-product__row"
                        >
                            <a href="javascript:void(0)"
                                ><img
                                    src="/img/product3.png"
                                    alt=""
                                    class="dashboard-product__img ofi"
                            /></a>
                            <a
                                href="javascript:void(0)"
                                class="dashboard-product__link app-link mr-auto"
                                ><span>Арт.</span>67896677776</a
                            >
                            <span>3000</span>
                            <span class="dashboard-product__pc">шт</span>
                        </div>
                        <div
                            class="d-flex justify-content-between align-items-center dashboard-product__row"
                        >
                            <a href="javascript:void(0)"
                                ><img
                                    src="/img/product3.png"
                                    alt=""
                                    class="dashboard-product__img ofi"
                            /></a>
                            <a
                                href="javascript:void(0)"
                                class="dashboard-product__link app-link mr-auto"
                                ><span>Арт.</span>67896677776</a
                            >
                            <span>500</span>
                            <span class="dashboard-product__pc">шт</span>
                        </div>
                        <div
                            class="d-flex justify-content-between align-items-center dashboard-product__row"
                        >
                            <a href="javascript:void(0)"
                                ><img
                                    src="/img/product3.png"
                                    alt=""
                                    class="dashboard-product__img ofi"
                            /></a>
                            <a
                                href="javascript:void(0)"
                                class="dashboard-product__link app-link mr-auto"
                                ><span>Арт.</span>67896677776</a
                            >
                            <span>300</span>
                            <span class="dashboard-product__pc">шт</span>
                        </div>
                    </div>
                </div>
                <!-- /dashboard-card__content -->
            </div>
            <!-- /dashboard-card -->
        </div>
        <!-- /dashboard-row  -->
    </section>
</template>

<script>
import initSelectPicker from '@/mixins/initSelectPicker'

export default {
    name: 'TopStats',
    mixins: [initSelectPicker],
    mounted() {
        this.initSelectPicker()
    }
}
</script>
